import { useQuery } from '@tanstack/react-query';
import { getCart } from '../../api/apiStorefront';

const extractCount = (response) => {
  const cart = response?.data?.data;
  if (!cart) return 0;
  if (typeof cart.total_items === 'number') return cart.total_items;
  if (Array.isArray(cart.items)) {
    return cart.items.reduce((sum, it) => sum + (Number(it.qty) || 0), 0);
  }
  return 0;
};

export const useCartCount = () => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['cart'],
    queryFn: getCart,
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });

  return {
    data: extractCount(data),
    isLoading,
    error,
    refetch,
  };
};
